import "./style.scss";
import { toJS } from "mobx";

const PreviewDisclaimer = ({ changeableData }) => {
    // console.log(toJS(changeableData));

    return (
        <div className={`preview__disclaimer`}>
            <div className="preview__disclaimer_modal">
                <div className="close__block">
                    <i className="pi pi-times close__block-icon" />
                </div>
                <div className="title">
                    <span dangerouslySetInnerHTML={{ __html: changeableData?.vendor?.ord }}></span>
                    <span>ERID:</span>
                </div>

                {changeableData?.disclaimer ? <div className="desc" dangerouslySetInnerHTML={{ __html: changeableData?.disclaimer }}></div> : <div className="placeholder">Текст дисклеймера появится после ввода</div>}
            </div>
        </div>
    );
};

export default PreviewDisclaimer;
